'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseButtons = require('@bibliocommons/base-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRINT_WINDOW_NAME = 'printWindow';
var PRINT_WINDOW_OPTIONS = (0, _lodash2.default)({
  resizable: 1,
  status: 0,
  toolbar: 0,
  scrollbars: 1,
  location: 0,
  menubar: 0
}).map(function (value, key) {
  return key + '=' + value;
}).value().join(',');

function PrintButton(_ref) {
  var url = _ref.url,
      iconColor = _ref.iconColor,
      className = _ref.className;

  var onClick = function onClick(e) {
    if (e.target && typeof e.target.blur === 'function') {
      e.target.blur();
    }

    // This is to prevent Microsoft Edge from exploding
    function stopFocus(focusEvent) {
      focusEvent.preventDefault();
      window.removeEventListener('focus', stopFocus);
    }
    window.addEventListener('focus', stopFocus);

    window.open(url, PRINT_WINDOW_NAME, PRINT_WINDOW_OPTIONS);
  };

  return _react2.default.createElement(
    _baseButtons.DefaultButton,
    { className: 'cp-print-button ' + className, 'data-test-id': 'print-view-button', href: url, tagName: 'a', flat: true, handleClick: onClick },
    _react2.default.createElement(_baseIcons.Printer, {
      color: iconColor }),
    _react2.default.createElement(
      _baseScreenReaderMessage2.default,
      null,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print_view' })
    )
  );
}

PrintButton.propTypes = {
  className: _react.PropTypes.string,
  iconColor: _react.PropTypes.string,
  url: _react.PropTypes.string.isRequired
};

exports.default = PrintButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-button/components/PrintButton.component.js
// module id = 1444
// module chunks = 1